module.exports = __webpack_public_path__ + "img/telegramm.e3f2f291.svg";